/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        const euCountries = [
          'AL',
          //'AT', // Austria
          'BY',
          'BA',
          'BE',
          'BG',
          'HR',
          'CY',
          'CZ',
          //'DE',
          'DK',
          'EE',
          'FI',
          'FR',
          'GR', // Greece
          //'HU', // Hungary
          'IT',
          'IE', // Ireland
          'KV', // Kosovo
          'LV', // Latvia
          'LT', // Lithuania
          'LU', // Luxembourg
          'MT', // Malta
          'NL', // Netherlands
          'NO', // Norway
          'PL', // Poland
          'PT', // Portugal
          'RO', // Romania
          'RS', // Serbia
          'SK', // Slovakia
          'SI', // Slovenia
          'ES', // Spain
          'SE', // Sweden
          'CH', // Switzerland
          'UA', // Ukraine
          'GB'  // United Kingdom
        ];

        const euSpecialCountries = [
            'AT',
            'DE',
            'HU'
        ];

        const naCountries = [
            'CA', // Canada
            'US',
            'AS', // US American Samoa
            'UM', // U.S. Minor Outlying Islands
            'VI', // U.S. Virgin Islands
            'MP', // US Northern Mariana Islands
            'GU', // US Guam
            'PR', // US Puerto Rico
        ];

        const host_url = window.location.host;
        const path = window.location.pathname;
        const countryCode = localStorage.getItem('country_code');

        // if (path.includes("my-account")){
        //     if (host_url === 'store.flux3dp.com'){
        //         window.location.replace('https://member.flux3dp.com/en-US')
        //     } else {
        //         window.location.replace('https://member.flux3dp.com/zh-TW')
        //     }
        //     return;
        // }

        if(host_url === 'store.flux3dp.com'
        && path.toLowerCase().indexOf("my-account") < 0
            && path.toLowerCase().indexOf("api_entry") < 0
            && path.toLowerCase().indexOf("flux-admin") < 0
            ){
            window.location.replace('https://shop.flux3dp.com/');
        }else if(host_url === 'tw-store.flux3dp.com'
                    && path.toLowerCase().indexOf("api_entry") < 0
                    && path.toLowerCase().indexOf("flux-admin") < 0
                    && path.toLowerCase().indexOf("my-account") < 0
        ){
            window.location.replace('https://tw-shop.flux3dp.com/');
        }

        if (localStorage.getItem('country_code') && localStorage.getItem('country_code') !== 'JP') {
            if (naCountries.includes(countryCode)){
            $('.home-hexa').hide();
            $('.elementor-element-2ef3042').hide();
            $('.elementor-repeater-item-58e416b').hide();

            }
            if (sessionStorage.getItem('banner-close') !== 'y') {
            console.log('country: ', countryCode);

            if (euCountries.includes(countryCode) && location.href.indexOf('beamo') === -1) {
                $('#eu-banner').show();
            }

            if (euCountries.includes(countryCode) && location.href.indexOf('beamo') > -1) {
                $('#eu-banner-beamo').show();
            }

            if (euSpecialCountries.includes(countryCode)) {
                $('#eu-banner-sp').show();
            }

            if (countryCode && countryCode.indexOf('HK') > -1) {
                $('#hk-banner').show();
            }

            $('.banner-close').click(function(){
                sessionStorage.setItem('banner-close', 'y');
                $('#hk-banner').hide();
                $('#eu-banner').hide();
                $('#eu-banner-beamo').hide();
                $('#eu-banner-sp').hide();
            });
            }
        } else {
            $.getJSON('/api_entry/?feature=my_country', (result) => {
            localStorage.setItem('country_code', result.country_code);
            if (naCountries.includes(countryCode)){
                $('.home-hexa').hide();
                $('.elementor-element-2ef3042').hide();
                $('.elementor-repeater-item-58e416b').hide();
            }
            if (sessionStorage.getItem('banner-close') !== 'y') {
                const countryCode = localStorage.getItem('country_code');

                console.log('country: ', countryCode);

                if (euCountries.includes(countryCode) && location.href.indexOf('beamo') === -1) {
                    $('#eu-banner').show();
                }

                if (euCountries.includes(countryCode) && location.href.indexOf('beamo') > -1) {
                    $('#eu-banner-beamo').show();
                }

                if (euSpecialCountries.includes(countryCode)) {
                    $('#eu-banner-sp').show();
                }

                if (countryCode && countryCode.indexOf('HK') > -1) {
                    $('#hk-banner').show();
                }

                $('.banner-close').click(function(){
                    sessionStorage.setItem('banner-close', 'y');
                    $('#hk-banner').hide();
                    $('#eu-banner').hide();
                    $('#eu-banner-beamo').hide();
                    $('#eu-banner-sp').hide();
                });
            }
        });
    }

    },
    finalize: function() {
      // JavaScript to be fired on all pages, after page specific JS is fired
      console.log("THIS IS main.jss");
    }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
